import {
  useState,
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef,
} from "react";
import search from "../../../assets/admin/search.svg";
import { toast } from "react-toastify";
import { RiArrowDownSLine } from "react-icons/ri";
import axios from "axios";
import { FaRegEye, FaTimes } from "react-icons/fa";
import { TbEdit } from "react-icons/tb";

import { MdCancel } from "react-icons/md";
import { CiFilter } from "react-icons/ci";
import defaultImage from "../../../utils/DefaultImage";
import PaginationComponent from "../../../utils/PaginationComponent";
import TableLoader from "../../../utils/TableLoader";
import WineView from "./WineView";
import WineEdit from "./WineEdit";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";

import { RiCheckLine } from "react-icons/ri";
import { RiRefreshLine } from "react-icons/ri";

const WineManagement = (props, ref) => {
  const { hasPermission } = props;
  //Refs
  const dropdownRef = useRef(null);

  const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
  const token = localStorage.getItem("token");

  // State Management: Data & Pagination
  const [wineData, setWineData] = useState([]);
  const [isLoading, setIsLoading] = useState({ main: false, edit: false });
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // State Management: Edit/View Mode
  const [currentWineData, setCurrentWineData] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isViewing, setIsViewing] = useState(false);
  const [wineName, setWineName] = useState("");
  const [b2bPrice, setB2bPrice] = useState("");
  const [glassPrice, setGlassPrice] = useState("");
  const [servedPrice, setServedPrice] = useState("");
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [openDropdownServedId, setOpenDropdownServedId] = useState(null);
  const [openDropdownQuantity, setOpenDropdownQuantity] = useState(null);

  // State Management: Search & Filters
  const [searchWine, setSearchWine] = useState(() => {
    const storedData = JSON.parse(localStorage.getItem("searchTexts")) || {};
    return storedData["Wine Management Text"] || "";
  });

  const [filteredNation, setFilteredNation] = useState("");
  const [filteredRegion, setFilteredRegion] = useState("");
  const [filteredWine, setFilteredWine] = useState("");
  const [filteredProductType, setFilteredProductType] = useState("");

  // State Management: Arrays to hold the fetched filter options
  const [filteredNationArray, setFilteredNationArary] = useState([]);
  const [filteredRegionArray, setFilteredRegionArary] = useState([]);
  const [filteredWineArray, setFilteredWineArary] = useState([]);
  const [filteredProductTypeArray, setFilteredProductTypeArary] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");

  const [selectedb2bPrice, setSelectedB2BPrice] = useState({});
  const [selectedServedPrice, setSelectedServedPrice] = useState({});
  const [selectedQuantities, setSelectedQuantities] = useState({});

  const handleB2BPriceSelect = (wineId, price) => {
    setSelectedB2BPrice(prev => ({
      ...prev,
      [wineId]: price
    }));
    setOpenDropdownServedId(null);
  }

  const handleServedPriceSelect = (wineId, price) => {
    setSelectedServedPrice(prev => ({
      ...prev,
      [wineId]: price
    }));

    // Optional: Close the dropdown after selection
    setOpenDropdownServedId(null);

    // If you need to perform any additional actions (like updating cart/order)
    // you can add them here
  };
  // State Management: Dropdown Options
  const [showOption, setShowOption] = useState({
    nation: false,
    region: false,
    wine: false,
    product_type: false,
  });

  // Toggle Dropdown for Filter Options
  const toggleDropdown = (key) => {
    setShowOption((prev) => ({
      nation: false,
      region: false,
      wine: false,
      product_type: false,
      [key]: !prev[key],
    }));
  };

  const toggleDropdownBox = (orderId) => {
    setOpenDropdownId(openDropdownId === orderId ? null : orderId);
  };

  const toggleDropdownBoxServed = (orderId) => {
    setOpenDropdownServedId(openDropdownServedId === orderId ? null : orderId);
  };
  const toggleDropdownBoxQuantity = (orderId) => {
    setOpenDropdownQuantity(openDropdownQuantity === orderId ? null : orderId);
  };

  const filteredNationArrays = filteredNationArray.filter((nation) =>
    nation.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const filteredRegionArrays = filteredRegionArray.filter((nation) =>
    nation.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const filteredWineArrays = filteredWineArray.filter((nation) =>
    nation.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const filteredProductTypeArrays = filteredProductTypeArray.filter((nation) =>
    nation.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const [showFilterForMobile, setShowFilterForMobile] = useState(false);

  const handleResize = () => {
    if (window.innerWidth >= 768) {
      setShowFilterForMobile(false);
    }
  };
  const handleResize2 = () => {
    if (window.innerWidth <= 768) {
      setShowFilterForMobile(true);
    }
  };

  const handleQuantitySelect = (wineId, quantity) => {
    const selectedWineMeta =
      wineData?.find((wine) => wine.id === wineId)?.meta || [];
    const matchedMeta = selectedWineMeta?.find(
      (meta) => meta.quantity === quantity
    );

    setSelectedQuantities((prev) => ({
      ...prev,
      [wineId]: quantity,
    }));

    if (matchedMeta) {
      setSelectedB2BPrice((prev) => ({
        ...prev,
        [wineId]: matchedMeta.b2b_price,
      }));
      setSelectedServedPrice((prev) => ({
        ...prev,
        [wineId]: matchedMeta.served_price,
      }));
    }

    setOpenDropdownQuantity(null);
  };

  // Fetch Wine Data for Listing
  const getWineData = async (atr, searchData) => {
    setIsLoading({ ...isLoading, main: true });
    setShowOption({
      nation: false,
      region: false,
      wine: false,
      product_type: false,
    });
    try {
      const params = {
        pageNumber: page,
        size: rowsPerPage,
      };
      if (atr === "search" || searchWine.length > 0) {
        if (atr === "search") {
          setPage(1);
          params.pageNumber = 1;
          if (searchData?.target?.value) {
            params.search = searchData?.target?.value;
          }
        } else {
          params.search = searchWine;
        }
      }
      if (atr !== "clear") {
        if (filteredNation.length > 0) {
          params.nation = filteredNation.join(",");
        }
        if (filteredRegion.length > 0) {
          params.region = filteredRegion.join(",");
        }
        if (filteredWine.length > 0) {
          params.wine = filteredWine.join(",");
        }
        if (filteredProductType.length > 0) {
          params.product_type = filteredProductType.join(",");
        }
      } else {
        setFilteredNation([]);
        setFilteredRegion([]);
        setFilteredWine([]);
        setFilteredProductType([]);
      }
      const response = await axios.get(`${apiUrl}/api/v1/wines`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response.data;
      setWineData(data.data);
      setTotalPages(data.total);
    } catch (error) {
      console.error("Error fetching wine data:", error);
    } finally {
      setIsLoading({ ...isLoading, main: false });
    }
  };

  // Fetch Filter Options for Dropdowns on Component Mount
  const getFilterOptions = async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/v1/wineFilterOptions`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response.data;
      setFilteredNationArary(data?.nations || []);
      setFilteredRegionArary(data?.regions || []);
      setFilteredWineArary(data?.grape_varieties || []);
      setFilteredProductTypeArary(data?.product_types || []);
    } catch (error) {
      console.error("Error fetching wine data:", error);
    }
  };

  // Filter Toggle Functions
  const handleNationFilter = (nation) => {
    if (!filteredNation.includes(nation)) {
      setFilteredNation((prevState) => [...prevState, nation]);
    } else {
      setFilteredNation((prevState) => prevState.filter((n) => n !== nation));
    }
  };

  const handleRegionFilter = (region) => {
    if (!filteredRegion.includes(region)) {
      setFilteredRegion((prevState) => [...prevState, region]);
    } else {
      setFilteredRegion((prevState) => prevState.filter((n) => n !== region));
    }
  };

  const handleWineFilter = (wine) => {
    if (!filteredWine.includes(wine)) {
      setFilteredWine((prevState) => [...prevState, wine]);
    } else {
      setFilteredWine((prevState) => prevState.filter((n) => n !== wine));
    }
  };

  const handleProductTypeFilter = (productType) => {
    if (!filteredProductType.includes(productType)) {
      setFilteredProductType((prevState) => [...prevState, productType]);
    } else {
      setFilteredProductType((prevState) =>
        prevState.filter((n) => n !== productType)
      );
    }
  };

  // Handle Click Events
  const handleEdit = (wine) => {
    setIsEditing(true);
    setIsViewing(false);
    setCurrentWineData(wine);
  };

  // View Handlers
  const handleView = (wine) => {
    setIsViewing(true);
    setIsEditing(false);
    setCurrentWineData(wine);
  };

  // Cancel Edit/View Mode
  const handleCancel = () => {
    setIsEditing(false);
    setIsViewing(false);
    setCurrentWineData(null);
  };

  // Save Wine Data after Editing
  const handleSave = async () => {
    setIsLoading({ ...isLoading, edit: true });
    try {
      const response = await axios.put(
        `${apiUrl}/api/v1/wines/${currentWineData?.id}`,
        {
          served_price: servedPrice,
          b2b_price: b2bPrice,
          glass_price: glassPrice,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status !== 200) {
        throw new Error("Failed to update wine data");
      }
      const updatedWine = response.data;
      toast.success("Wine updated successfully:", updatedWine);
      setIsEditing(false);
      getWineData();
    } catch (error) {
      toast.error(error?.response?.data?.error, {
        theme: "colored",
        autoClose: 1000,
      });
      console.error("Error updating wine data:", error);
    } finally {
      setIsLoading({ ...isLoading, edit: false });
    }
  };

  useImperativeHandle(ref, () => ({
    wine() {
      setIsEditing(false);
      setIsViewing(false);
      setCurrentWineData(null);
    },
  }));

  useEffect(() => {
    getWineData();
    getFilterOptions();
  }, [page, rowsPerPage]);

  useEffect(() => {
    setSearchQuery("");
  }, [showOption]);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize2);
    return () => {
      window.removeEventListener("resize", handleResize2);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOption({
          nation: false,
          region: false,
          wine: false,
          product_type: false,
        });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (
      currentWineData?.name ||
      currentWineData?.b2b_price ||
      currentWineData?.glass_price ||
      currentWineData?.served_price
    ) {
      setWineName(currentWineData?.name);
      setB2bPrice(currentWineData?.b2b_price);
      setGlassPrice(currentWineData?.glass_price);
      setServedPrice(currentWineData?.served_price);
    }
  }, [currentWineData]);

  useEffect(() => {
    const initialB2BPrice = {};
    const initialServedPrice = {};
    const initialQuantities = {};

    wineData.forEach((wine) => {
      if (wine.meta && wine.meta.length > 0) {
        const firstMeta = wine.meta[0];
        initialB2BPrice[wine.id] = firstMeta.b2b_price;
        initialServedPrice[wine.id] = firstMeta.served_price;
        initialQuantities[wine.id] = firstMeta.quantity;
      }
    });

    setSelectedB2BPrice(initialB2BPrice);
    setSelectedServedPrice(initialServedPrice);
    setSelectedQuantities(initialQuantities);
  }, [wineData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest(`.dropdown-container-${openDropdownId}`) &&
        !event.target.closest(`.dropdown-container-${openDropdownServedId}`) &&
        !event.target.closest(`.dropdown-container-${openDropdownQuantity}`)
      ) {
        setOpenDropdownId(null);
        setOpenDropdownServedId(null);
        setOpenDropdownQuantity(null);
      }
    };
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openDropdownId, openDropdownServedId, openDropdownQuantity]);

  useEffect(() => {
    const handlePageRefresh = () => {
      let searchTexts = JSON.parse(localStorage.getItem("searchTexts")) || {};
      delete searchTexts["Wine Management Text"];
      localStorage.setItem("searchTexts", JSON.stringify(searchTexts));
    };

    window.addEventListener("beforeunload", handlePageRefresh);

    return () => {
      window.removeEventListener("beforeunload", handlePageRefresh);
    };
  }, []);

  return (
    <>
      {!isEditing && !isViewing ? (
        <section className="border-t border-[#D9D9D9] sm:mt-5 pt-8">
          <h3 className="text-3xl text-left  font-bold mb-2 poppins-medium">
            Tutti i vini
          </h3>
          {(filteredNation.length > 0 ||
            filteredRegion.length > 0 ||
            filteredWine.length > 0 ||
            filteredProductType.length > 0) && (
              <div className="flex flex-col gap-5 pt-4 pb-1">
                <h1 className="text-lg font-medium">Filtri Selezionati</h1>
                <div className="flex flex-wrap gap-3">
                  {filteredNation.length > 0 &&
                    filteredNation?.map((item) => {
                      return (
                        <div
                          key={item}
                          className="flex w-fit items-center gap-1 px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200"
                        >
                          <p className="m-0 w-fit text-sm">{item}</p>
                          <FaTimes
                            className="text-red-500 cursor-pointer"
                            onClick={() => handleNationFilter(item)}
                            title="Remove"
                          />
                        </div>
                      );
                    })}
                  {filteredRegion.length > 0 &&
                    filteredRegion?.map((item) => {
                      return (
                        <div
                          key={item}
                          className="flex w-fit items-center gap-1 px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200"
                        >
                          <p className="m-0 w-fit text-sm">{item}</p>
                          <FaTimes
                            className="text-red-500 cursor-pointer"
                            onClick={() => handleRegionFilter(item)}
                            title="Remove"
                          />
                        </div>
                      );
                    })}
                  {filteredWine.length > 0 &&
                    filteredWine?.map((item) => {
                      return (
                        <div
                          key={item}
                          className="flex w-fit items-center gap-1 px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200"
                        >
                          <p className="m-0 w-fit text-sm">{item}</p>
                          <FaTimes
                            className="text-red-500 cursor-pointer"
                            onClick={() => handleWineFilter(item)}
                            title="Remove"
                          />
                        </div>
                      );
                    })}
                  {filteredProductType.length > 0 &&
                    filteredProductType?.map((item) => {
                      return (
                        <div
                          key={item}
                          className="flex w-fit items-center gap-1 px-2 py-1 border rounded bg-gray-100 hover:bg-gray-200"
                        >
                          <p className="m-0 w-fit text-sm">{item}</p>
                          <FaTimes
                            className="text-red-500 cursor-pointer"
                            onClick={() => handleProductTypeFilter(item)}
                            title="Remove"
                          />
                        </div>
                      );
                    })}
                </div>
              </div>
            )}
          <div className="w-full flex gap-3 items-center my-5 justify-center flex-wrap">
            <div className="w-full flex xl:flex-row flex-col gap-2 justify-between">
              <div className="w-full">
                <div ref={dropdownRef}>
                  <h1 className="text-xl flex items-center justify-between italic font-bold poppins-medium mb-3">
                    Filtri:
                    <div className="sm:hidden block">
                      {showFilterForMobile ? (
                        <CiFilter
                          onClick={() => {
                            setShowFilterForMobile(!showFilterForMobile);
                          }}
                          color="gray"
                          size={"30px"}
                        />
                      ) : (
                        <MdCancel
                          onClick={() => {
                            setShowFilterForMobile(!showFilterForMobile);
                          }}
                          color="gray"
                          size={"30px"}
                        />
                      )}
                    </div>
                  </h1>
                  <div
                    className={`${showFilterForMobile
                      ? "hidden transition-all duration-500 ease-in-out"
                      : ""
                      // } grid my-3 xl:grid-cols-5 lg:grid-cols-3 md:grid-cols-2 gap-3`}
                      } flex flex-wrap gap-[10px] my-3`}
                  >
                    {/* Nation Filter */}
                    <div className="relative group w-full flex-none 2xl:flex-1 lg:max-w-[calc(33%-8px)] md:max-w-[calc(50%-8px)] dropdown-container">
                      <button
                        className={`${showOption.nation
                          ? "border border-[#8B24335C] rounded-tl-3xl rounded-tr-3xl"
                          : "rounded-full"
                          } border border-[#8B24335C] bg-[#FAF6F6] inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
                        onClick={() => toggleDropdown("nation")}
                      >
                        <span className="mr-2 flex items-center gap-3 poppins-medium">
                          Nazione
                        </span>
                        <RiArrowDownSLine
                          className={`transform transition-transform duration-300 ${showOption.nation ? "rotate-180" : ""
                            }`}
                          size={"20px"}
                        />
                      </button>
                      <div
                        className={`${showOption.nation
                          ? "opacity-100 z-50"
                          : "opacity-0 z-20 hidden"
                          } bg-[#FAF6F6] h-[320px] border border-[#8B24335C] overflow-y-scroll absolute top-[32px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full  transition-all duration-300 ease-in-out`}
                      >
                        <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[21px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                          <img
                            src={search}
                            className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                            alt="Search"
                          />
                          <input
                            type="text"
                            className="block poppins-regular bg-transparent outline-none w-full placeholder:text-sm"
                            placeholder="..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                          />
                        </div>
                        {filteredNationArrays?.length > 0 ? (
                          filteredNationArrays?.map((nation) => (
                            <label
                              htmlFor=""
                              key={nation}
                              className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                            >
                              <input
                                type="checkbox"
                                className="outline-none cursor-pointer"
                                checked={filteredNation.includes(nation)}
                                onChange={() => handleNationFilter(nation)}
                              />
                              <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                                {nation}
                              </span>
                            </label>
                          ))
                        ) : (
                          <label
                            htmlFor=""
                            className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                          >
                            <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                              No nazione data available
                            </span>
                          </label>
                        )}
                      </div>
                    </div>
                    {/* Region Filter */}
                    <div className="relative group   w-full flex-none 2xl:flex-1 lg:max-w-[calc(33%-8px)] md:max-w-[calc(50%-8px)] dropdown-container">
                      <button
                        className={`${showOption.region
                          ? "border border-[#8B24335C] rounded-tl-3xl rounded-tr-3xl"
                          : "rounded-full"
                          } border border-[#8B24335C] bg-[#FAF6F6]  inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
                        onClick={() => toggleDropdown("region")}
                      >
                        <span className="mr-2flex items-center gap-3 poppins-medium">
                          Regione
                        </span>
                        <RiArrowDownSLine
                          className={`transform transition-transform duration-300 ${showOption.region ? "rotate-180" : ""
                            }`}
                          size={"20px"}
                        />
                      </button>
                      <div
                        className={`${showOption.region
                          ? "opacity-100 z-50"
                          : "opacity-0 z-20 hidden"
                          } bg-[#FAF6F6] h-[320px] border border-[#8B24335C] overflow-y-scroll absolute top-[32px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full  transition-all duration-300 ease-in-out`}
                      >
                        <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[21px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                          <img
                            src={search}
                            className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                            alt="Search"
                          />
                          <input
                            type="text"
                            className="block poppins-regular bg-transparent outline-none w-full placeholder:text-sm"
                            placeholder="..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                          />
                        </div>
                        {filteredRegionArrays?.length > 0 ? (
                          filteredRegionArrays?.map((region) => (
                            <label
                              htmlFor=""
                              key={region}
                              className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                            >
                              <input
                                type="checkbox"
                                className="outline-none cursor-pointer"
                                checked={filteredRegion.includes(region)}
                                onChange={() => handleRegionFilter(region)}
                              />
                              <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                                {region}
                              </span>
                            </label>
                          ))
                        ) : (
                          <label
                            htmlFor=""
                            className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                          >
                            <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                              No regione data available
                            </span>
                          </label>
                        )}
                      </div>
                    </div>
                    {/* Wine Filter */}
                    <div className="relative group   w-full flex-none 2xl:flex-1 lg:max-w-[calc(33%-8px)] md:max-w-[calc(50%-8px)] dropdown-container">
                      <button
                        className={`${showOption.wine
                          ? "border border-[#8B24335C] rounded-tl-3xl rounded-tr-3xl"
                          : "rounded-full"
                          } border border-[#8B24335C] bg-[#FAF6F6]  inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
                        onClick={() => toggleDropdown("wine")}
                      >
                        <span className="mr-2flex items-center gap-3 poppins-medium">
                          Vitigno
                        </span>
                        <RiArrowDownSLine
                          className={`transform transition-transform duration-300 ${showOption.wine ? "rotate-180" : ""
                            }`}
                          size={"20px"}
                        />
                      </button>
                      <div
                        className={`${showOption.wine
                          ? "opacity-100 z-50"
                          : "opacity-0 z-20 hidden"
                          } bg-[#FAF6F6] h-[320px] border border-[#8B24335C] overflow-y-scroll absolute top-[32px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full  transition-all duration-300 ease-in-out`}
                      >
                        <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[21px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                          <img
                            src={search}
                            className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                            alt="Search"
                          />
                          <input
                            type="text"
                            className="block poppins-regular bg-transparent outline-none w-full placeholder:text-sm"
                            placeholder="..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                          />
                        </div>
                        {filteredWineArrays?.length > 0 ? (
                          filteredWineArrays?.map((wine) => (
                            <label
                              htmlFor=""
                              key={wine}
                              className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                            >
                              <input
                                type="checkbox"
                                className="outline-none cursor-pointer"
                                checked={filteredWine.includes(wine)}
                                onChange={() => handleWineFilter(wine)}
                              />
                              <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                                {wine}
                              </span>
                            </label>
                          ))
                        ) : (
                          <label
                            htmlFor=""
                            className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                          >
                            <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                              No vitigno data available
                            </span>
                          </label>
                        )}
                      </div>
                    </div>
                    {/* Product Type Filter */}
                    <div className="relative group  w-full flex-none 2xl:flex-1  lg:max-w-[calc(33%-8px)] md:max-w-[calc(50%-8px)] dropdown-container">
                      <button
                        className={`${showOption.product_type
                          ? "border border-[#8B24335C] rounded-tl-3xl rounded-tr-3xl"
                          : "rounded-full"
                          } border border-[#8B24335C] bg-[#FAF6F6]  inline-flex justify-between items-center w-full px-4 py-2 outline-none text-[#DB7685] shadow-sm relative z-30`}
                        onClick={() => toggleDropdown("product_type")}
                      >
                        <span className="mr-2 flex items-center gap-3 poppins-medium">
                          Tipologia
                        </span>
                        <RiArrowDownSLine
                          className={`transform transition-transform duration-300 ${showOption.product_type ? "rotate-180" : ""
                            }`}
                          size={"20px"}
                        />
                      </button>
                      <div
                        className={`${showOption.product_type
                          ? "opacity-100 z-50"
                          : "opacity-0 z-20 hidden"
                          } bg-[#FAF6F6] h-[320px] border border-[#8B24335C] overflow-y-scroll absolute top-[32px] pt-[9px] rounded-t-none border-t-0 p-2 px-4 right-0 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full  transition-all duration-300 ease-in-out`}
                      >
                        <div className="flex px-[10px] py-[5px] flex-row relative border rounded-[21px] bg-[#f6efef66] my-[5px] justify-around gap-x-2">
                          <img
                            src={search}
                            className="block left-0 top-0 bottom-0 my-auto h-4 w-4"
                            alt="Search"
                          />
                          <input
                            type="text"
                            className="block poppins-regular bg-transparent outline-none w-full placeholder:text-sm"
                            placeholder="..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                          />
                        </div>
                        {filteredProductTypeArrays?.length > 0 ? (
                          filteredProductTypeArrays?.map((productType) => (
                            <label
                              htmlFor=""
                              key={productType}
                              className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                            >
                              <input
                                type="checkbox"
                                checked={filteredProductType.includes(
                                  productType
                                )}
                                className="outline-none cursor-pointer"
                                onChange={() =>
                                  handleProductTypeFilter(productType)
                                }
                              />
                              <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                                {productType}
                              </span>
                            </label>
                          ))
                        ) : (
                          <label
                            htmlFor=""
                            className="border-t border-[#8b24331f] px-0 py-2 flex align-center justify-between flex-row-reverse gap-[15px] filter_list_btn"
                          >
                            <span className="text-[#6B6B6B] rounded-md flex items-center gap-3 poppins-regular text-sm">
                              No tipologia data available
                            </span>
                          </label>
                        )}
                      </div>
                    </div>
                    <div className="flex gap-2 ">
                      <button
                        className="w-auto  flex justify-center py-2 ps-4 pe-5 items-center text-sm bg-[#8A2533] text-white rounded-3xl border-2 border-[#953543] hover:text-[#8A2533] hover:bg-[#f6efef] transition-colors group"
                        onClick={() => {
                          setPage(1);
                          getWineData();
                        }}
                      >
                        <RiCheckLine className="w-4 h-4 mr-2" />
                        <span className="poppins-regular text-sm">Applica</span>
                      </button>
                      <button
                        className="w-auto flex justify-center py-2 ps-4 pe-5 items-center text-sm bg-[#8A2533] text-white rounded-3xl border-2 border-[#953543] hover:text-[#8A2533] hover:bg-[#f6efef] transition-colors group"
                        onClick={() => {
                          setPage(1);
                          getWineData("clear");
                        }}
                      >
                        <RiRefreshLine className="w-4 h-4 mr-2" />
                        <span className="poppins-regular text-sm">
                          Reimposta
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
                {/* Search Input */}
                <div className="relative group w-full">
                  <button
                    className="inline-flex h-full justify-between items-center w-full px-6 pl-8 py-2 outline-none text-[#8F8F8F] border border-[#D9D9D9] rounded-full shadow-sm"
                    onClick={() => toggleDropdown("searchWine")}
                  >
                    <input
                      type="text"
                      placeholder="Cerca vino"
                      className="text-[#8F8F8F] outline-none pl-4 poppins-medium relative w-full h-full"
                      value={searchWine}
                      onChange={(e) => {
                        getWineData("search", e);
                        setSearchWine(e.target.value);
                        let searchTexts =
                          JSON.parse(localStorage.getItem("searchTexts")) || {};
                        searchTexts["Wine Management Text"] = e.target.value;
                        localStorage.setItem(
                          "searchTexts",
                          JSON.stringify(searchTexts)
                        );
                      }}
                    />

                    <img
                      src={search}
                      className="absolute left-4 top-0 bottom-0 my-auto h-4 w-4"
                      alt="Search"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className=" wine-main-table w-auto h-auto bg-[#FBFBFB] border-[2px] border-[#8B24332B] px-6 pt-3 pb-0 rounded-xl shadow">
            <table className="w-full text-left wine_table">
              <thead>
                <tr className="border-b border-[#8B2433]">
                  <th className="pb-3 pr-2 text-left poppins-medium text-[#6B6B6B]">
                    Immagine
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Nome
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Tipologia
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Nazione
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Quantità
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Prezzo Horeca
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    {/* Prezzo Servito */}
                    Prezzo Bottiglia
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Stato
                  </th>
                  {(hasPermission("Wines", "edit") ||
                    hasPermission("Wines", "view")) && (
                      <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B] w-[9%]">
                        Opzioni
                      </th>
                    )}
                </tr>
              </thead>
              {isLoading?.main ? (
                <TableLoader />
              ) : (
                <tbody>
                  {wineData?.length ? (
                    wineData?.map((wine, index) => (
                      <tr
                        key={index}
                        className="border-b border-[#8B2433]/12 text-sm"
                      >
                        <td className="pr-2 py-4">
                          <div className="relative thumbnail_image rounded-lg w-[50px] h-[60px] bg-white p-1 flex align-center justify-center">
                            <img
                              className="w-[100px] h-100 object-contain border border-[#68172394] rounded-lg p-1"
                              src={
                                wine?.image && wine?.image !== ""
                                  ? wine?.image
                                  : defaultImage
                              }
                            />
                            <td className="text-left poppins-medium text-[#303030] top-[-9px] right-[-5px] absolute">
                              {wine?.meta?.length > 1 && (
                                <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                                  <div
                                    className="w-2 h-2 bg-yellow-500 rounded-full shadow-lg"
                                    title="This product has multiple rates"
                                  ></div>
                                </span>
                              )}
                            </td>
                          </div>
                        </td>
                        <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                          {wine?.name || "N/A"}
                        </td>
                        <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                          {wine?.product_type || "N/A"}
                        </td>
                        <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                          {wine?.nation || "N/A"}
                        </td>
                        <td className="py-4 px-5 text-left poppins-medium text-[#303030]">
                          {/* <div
                            className={`relative group w-auto bg-[#FFFFFF] dropdown-container-${wine?.id}`}
                          >
                            <div className="border border-gray-300 rounded-3xl">
                              <div
                                onClick={() =>
                                  toggleDropdownBoxQuantity(wine?.id)
                                }
                                className="flex justify-between items-center w-full text-xs text-[#8B8B8B] rounded-3xl bg-transparent cursor-pointer relative z-10"
                              >
                                <span className="inline-flex items-center justify-center bg-[#8B2433A6] text-white rounded-full min-w-[32px] h-[32px]">
                                  {selectedQuantities[wine?.id] || "0"}
                                </span>

                                <RiArrowDownSLine
                                  className={`ml-1 mr-2 transform transition-transform duration-300 ${
                                    openDropdownQuantity === wine?.id
                                      ? "rotate-180"
                                      : ""
                                  }`}
                                  size={"15px"}
                                />
                              </div>
                              {openDropdownQuantity === wine?.id && (
                                <div className="z-[99] max-h-60 bg-[#FFFFFF] absolute top-[36px] p-2 px-4 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full transition-all duration-300 ease-in-out">
                                  {wine?.meta?.map((item) => (
                                    <label
                                      key={item?.id}
                                      onClick={() =>
                                        handleQuantitySelect(
                                          wine?.id,
                                          item?.quantity
                                        )
                                      }
                                      className="px-0 py-2 cursor-pointer flex items-center justify-center flex-row gap-[15px] filter_list_btn"
                                    >
                                      <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                                        {item?.quantity}
                                      </span>
                                    </label>
                                  ))}
                                  {wine?.meta?.length === 0 && (
                                    <label>
                                      <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                                        0
                                      </span>
                                    </label>
                                  )}
                                </div>
                              )}
                            </div>
                          </div> */}
                          {/* <div className={`relative group w-auto bg-[#FFFFFF] dropdown-container-${wine?.id}`}>
                            <Menu>
                              <div className="border border-gray-300 rounded-3xl">
                                <MenuButton
                                  onClick={() => toggleDropdownBoxQuantity(wine?.id)}
                                  className="flex justify-between items-center w-full text-xs text-[#8B8B8B] rounded-3xl bg-transparent cursor-pointer relative z-10"
                                >
                                  <span className="inline-flex items-center justify-center bg-[#8B2433A6] text-white rounded-full min-w-[32px] h-[32px]">
                                    {selectedQuantities[wine?.id] || "0"}
                                  </span>
                                  <RiArrowDownSLine
                                    className={`ml-1 mr-2 transform transition-transform duration-300 group-aria-expanded:rotate-180 translate-y-[-50%] ${open ? "rotate-180" : ""}`}
                                    size={"20px"}
                                  />
                                </MenuButton>
                              </div>

                              <MenuItems
                                anchor="bottom"
                                className="mt-4 bg-[#fffbfb] border w-[100px] text-black py-0 flex flex-col shadow-2xl rounded-xl relative focus-visible:outline-none overflow-hidden"
                              >
                                {wine?.meta?.map((item) => (
                                  <MenuItem key={item?.id}>
                                    {({ active }) => ( // Destructure the active prop here
                                      <button
                                        onClick={() => handleQuantitySelect(wine?.id, item?.quantity)}
                                        className={`px-0 py-2 w-full cursor-pointer flex items-center justify-center flex-row gap-[15px] ${active ? 'bg-gray-100' : ''
                                          }`}
                                      >
                                        <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                                          {item?.quantity}
                                        </span>
                                      </button>
                                    )}
                                  </MenuItem>
                                ))}

                                {wine?.meta?.length === 0 && (
                                  <MenuItem disabled>
                                    <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                                      0
                                    </span>
                                  </MenuItem>
                                )}
                              </MenuItems>
                            </Menu>
                          </div> */}
                          <div className={`w-[65px] relative group bg-[#FFFFFF] dropdown-container-${wine?.id}`}>
                            <Menu>
                              {({ open }) => (
                                <>
                                  <div className={` ${wine?.meta?.length > 1 ? ' border border-gray-300 rounded-3xl wine-dropdown' : "without-arrow"}`}>
                                    <MenuButton
                                      onClick={() => wine?.meta?.length > 1 && toggleDropdownBoxQuantity(wine?.id)}
                                      disabled={wine?.meta?.length <= 1}
                                      className={`flex justify-between items-center w-full text-xs text-[#8B8B8B] rounded-3xl bg-transparent cursor-pointer relative z-10 ${wine?.meta?.length <= 1 ? 'pointer-events-none' : ''
                                        }`}
                                    >
                                      <span className="inline-flex items-center justify-center bg-[#8B2433A6] text-white rounded-full min-w-[32px] h-[32px]">
                                        {selectedQuantities[wine?.id] || (wine?.meta?.[0]?.quantity || "0")}
                                      </span>
                                      {wine?.meta?.length > 1 && (
                                        <RiArrowDownSLine
                                          className={`absolute top-1/2 right-0 ml-1 mr-2 transform transition-transform duration-300 group-aria-expanded:rotate-180 translate-y-[-50%] ${open ? "rotate-180" : ""
                                            }`}
                                          size={20}
                                        />
                                      )}
                                    </MenuButton>
                                  </div>

                                  {wine?.meta?.length > 1 && (
                                    <MenuItems
                                      anchor="bottom"
                                      className="wine-dropdown-wrapper z-[9999] mt-1 bg-[#fffbfb] border w-[65px] text-black py-0 flex flex-col shadow-2xl rounded-2xl relative focus-visible:outline-none overflow-hidden"
                                    >
                                      {wine?.meta?.map((item) => (
                                        <MenuItem key={item?.id}>
                                          {({ active }) => (
                                            <button
                                              onClick={() => handleQuantitySelect(wine?.id, item?.quantity)}
                                              className={`px-0 py-2 w-full cursor-pointer border-t flex items-center justify-center flex-row gap-[15px] ${active ? 'bg-[#8A2533] ' : ''
                                                }`}
                                            >
                                              <span className={`text-xs text-[#303030] rounded-md flex items-center gap-3 poppins-regular ${active ? 'text-white' : ''}`}>
                                                {item?.quantity}
                                              </span>
                                            </button>
                                          )}
                                        </MenuItem>
                                      ))}
                                    </MenuItems>
                                  )}
                                </>
                              )}
                            </Menu>
                          </div>
                        </td>
                        <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                          {/* <div
                            className={`relative group w-auto bg-[#FFFFFF] dropdown-container-${wine?.id}`}
                          >
                            <div className="border border-gray-300 rounded-3xl">
                              <div
                                onClick={() => toggleDropdownBox(wine?.id)}
                                className="flex justify-between items-center w-full px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent cursor-pointer relative z-10"
                              >
                                <span className="mr-2 flex items-center gap-3 poppins-medium">
                                  {selectedb2bPrice[wine?.id] || "0.00"}
                                </span>
                                <RiArrowDownSLine
                                  className={`transform transition-transform duration-300 ${
                                    openDropdownId === wine?.id
                                      ? "rotate-180"
                                      : ""
                                  }`}
                                  size={"15px"}
                                />
                              </div>
                              {openDropdownId === wine?.id && (
                                <div className="z-[99] max-h-60 bg-[#FFFFFF] absolute top-[47px] p-2 px-4 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full transition-all duration-300 ease-in-out">
                                  {wine?.meta &&
                                    wine?.meta?.map((item) => (
                                      <label
                                        key={item?.id}
                                        className="px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn"
                                      >
                                        <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                                          {item?.b2b_price}
                                        </span>
                                      </label>
                                    ))}
                                  {wine?.meta?.length === 0 && (
                                    <label>
                                      <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                                        0.00
                                      </span>
                                    </label>
                                  )}
                                </div>
                              )}
                            </div>
                          </div> */}
                          {/* <div className={`relative group w-auto bg-[#FFFFFF] dropdown-container-${wine?.id}`}>
                            <Menu>
                              <div className="border border-gray-300 rounded-3xl">
                                <MenuButton
                                  onClick={() => toggleDropdownBox(wine?.id)}
                                  className="flex justify-between items-center w-full px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent cursor-pointer relative z-10"
                                >
                                  <span className="mr-2 flex items-center gap-3 poppins-medium">
                                    {selectedb2bPrice[wine?.id] || "0.00"}
                                  </span>
                                  <RiArrowDownSLine
                                    className={`transform transition-transform duration-300 ${openDropdownId === wine?.id ? "rotate-180" : ""
                                      }`}
                                    size={"15px"}
                                  />
                                </MenuButton>

                                <MenuItems
                                  anchor="bottom"
                                  className="mt-4 bg-[#fffbfb] border w-[100px] text-black py-0 flex flex-col shadow-2xl rounded-xl relative focus-visible:outline-none overflow-hidden"
                                >
                                  {wine?.meta?.length > 0 ? (
                                    wine?.meta?.map((item) => (
                                      <MenuItem key={item?.id}>
                                        {({ active }) => (
                                          <button
                                            onClick={() => handleB2BPriceSelect(wine?.id, item?.b2b_price)}
                                            className={`px-0 py-2 w-full cursor-pointer flex justify-between flex-row gap-[15px] ${active ? 'bg-gray-100' : ''
                                              }`}
                                          >
                                            <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                                              {item?.b2b_price}
                                            </span>
                                          </button>
                                        )}
                                      </MenuItem>
                                    ))
                                  ) : (
                                    <MenuItem disabled>
                                      <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                                        0.00
                                      </span>
                                    </MenuItem>
                                  )}
                                </MenuItems>
                              </div>
                            </Menu>
                          </div> */}
                          <div className={`relative group w-auto bg-[#FFFFFF] dropdown-container-${wine?.id}`}>
                            {/* <div className={`w-[65px] relative group bg-[#FFFFFF] dropdown-container-${wine?.id}`}> */}
                            <Menu>
                              {({ open }) => (
                                <>
                                  <div className={`border border-gray-300 rounded-3xl ${wine?.meta?.length > 1 ? 'w-[85px]' : "w-[75px]"}`}>
                                    <MenuButton
                                      onClick={() => wine?.meta?.length > 1 && toggleDropdownBox(wine?.id)}
                                      disabled={wine?.meta?.length <= 1}
                                      className={`flex justify-between items-center w-full px-4 py-2 text-xs text-[#8B8B8B] rounded-3xl bg-transparent cursor-pointer relative z-10 ${wine?.meta?.length <= 1 ? 'pointer-events-none' : ''
                                        }`}
                                    >
                                      <span className="mr-2 flex items-center gap-3 poppins-medium">
                                        {selectedb2bPrice[wine?.id] || (wine?.meta?.[0]?.b2b_price || "0.00")}
                                      </span>
                                      {wine?.meta?.length > 1 && (
                                        <RiArrowDownSLine
                                          className={`absolute top-1/2 right-0 ml-1 mr-2 transform transition-transform duration-300 group-aria-expanded:rotate-180 translate-y-[-50%] ${open ? "rotate-180" : ""
                                            }`}
                                          size={20}
                                        />
                                      )}
                                    </MenuButton>
                                  </div>
                                  {wine?.meta?.length > 1 && (
                                    <MenuItems
                                      anchor="bottom"
                                      className="z-[999] mt-2 bg-[#fffbfb] border w-[85px] text-black py-0 flex flex-col shadow-2xl rounded-xl relative focus-visible:outline-none overflow-hidden"
                                    >
                                      {wine?.meta?.map((item) => (
                                        <MenuItem key={item?.id}>
                                          {({ active }) => (
                                            <button
                                              onClick={() => handleB2BPriceSelect(wine?.id, item?.b2b_price)}
                                              className={`px-3 py-2 w-full cursor-pointer border-t flex justify-center flex-row gap-[15px] ${active ? 'bg-[#8a2533]' : ''
                                                }`}
                                            >
                                              <span className={`text-xs text-[#303030] rounded-md flex items-center gap-3 poppins-regular ${active ? 'text-white' : ''
                                                }`}>
                                                {item?.b2b_price}
                                              </span>
                                            </button>
                                          )}
                                        </MenuItem>
                                      ))}
                                    </MenuItems>
                                  )}
                                </>
                              )}
                            </Menu>
                          </div>
                        </td>
                        <td className="py-4 px-2 text-left poppins-medium text-[#303030]">
                          {/* <div
                            className={`relative group w-auto bg-[#FFFFFF] dropdown-container-${wine?.id}`}
                          >
                            <div className="border border-gray-300 rounded-3xl">
                              <div
                                onClick={() =>
                                  toggleDropdownBoxServed(wine?.id)
                                }
                                className="flex justify-between items-center w-full px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent cursor-pointer relative z-10"
                              >
                                <span className="mr-2 flex items-center gap-3 poppins-medium">
                                  {selectedServedPrice[wine?.id] || "0.00"}
                                </span>
                                <RiArrowDownSLine
                                  className={`transform transition-transform duration-300 ${
                                    openDropdownServedId === wine?.id
                                      ? "rotate-180"
                                      : ""
                                  }`}
                                  size={"15px"}
                                />
                              </div>
                              {openDropdownServedId === wine?.id && (
                                <div className="z-[99] max-h-60 bg-[#FFFFFF] absolute top-[47px] p-2 px-4 mt-0 rounded-[21px] shadow-lg text-[#DB7685] space-y-1 w-full transition-all duration-300 ease-in-out">
                                  {wine?.meta &&
                                    wine?.meta?.map((item) => (
                                      <label
                                        key={item?.id}
                                        className="px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn"
                                      >
                                        <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                                          {item?.served_price}
                                        </span>
                                      </label>
                                    ))}
                                  {wine?.meta?.length === 0 && (
                                    <label>
                                      <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                                        0.00
                                      </span>
                                    </label>
                                  )}
                                </div>
                              )}
                            </div>
                          </div> */}
                          {/* <div className={`relative group w-auto bg-[#FFFFFF] dropdown-container-${wine?.id}`}>
                            <Menu>
                              <div className="border border-gray-300 rounded-3xl">
                                <MenuButton
                                  onClick={() => toggleDropdownBoxServed(wine?.id)}
                                  className="flex justify-between items-center w-full px-4 py-3 text-xs text-[#8B8B8B] rounded-3xl bg-transparent cursor-pointer relative z-10"
                                >
                                  <span className="mr-2 flex items-center gap-3 poppins-medium">
                                    {selectedServedPrice[wine?.id] || "0.00"}
                                  </span>
                                  <RiArrowDownSLine
                                    className={`transform transition-transform duration-300 ${openDropdownServedId === wine?.id ? "rotate-180" : ""
                                      }`}
                                    size={"15px"}
                                  />
                                </MenuButton>

                                <MenuItems
                                  anchor="bottom"
                                  className="mt-4 bg-[#fffbfb] border w-[100px] text-black py-0 flex flex-col shadow-2xl rounded-xl relative focus-visible:outline-none overflow-hidden"
                                >
                                  {wine?.meta?.length > 0 ? (
                                    wine?.meta?.map((item) => (
                                      <MenuItem key={item?.id}>
                                        {({ active }) => (
                                          <button
                                            onClick={() => handleServedPriceSelect(wine?.id, item?.served_price)}
                                            className={`px-0 py-2 w-full cursor-pointer flex justify-between flex-row gap-[15px] ${active ? 'bg-gray-100' : ''
                                              }`}
                                          >
                                            <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                                              {item?.served_price}
                                            </span>
                                          </button>
                                        )}
                                      </MenuItem>
                                    ))
                                  ) : (
                                    <MenuItem disabled>
                                      <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                                        0.00
                                      </span>
                                    </MenuItem>
                                  )}
                                </MenuItems>
                              </div>
                            </Menu>
                          </div> */}
                          <div className={`relative group w-auto bg-[#FFFFFF] dropdown-container-${wine?.id}`}>
                            <Menu>
                              {({ open }) => (
                                <>
                                  {/* <div className="border border-gray-300 rounded-3xl w-[85px]"> */}
                                  <div className={`border border-gray-300 rounded-3xl ${wine?.meta?.length > 1 ? 'w-[85px]' : "w-[75px]"}`}>
                                    <MenuButton
                                      onClick={() => wine?.meta?.length > 1 && toggleDropdownBox(wine?.id)}
                                      disabled={wine?.meta?.length <= 1}
                                      className={`flex justify-between items-center w-full px-4 py-2 text-xs text-[#8B8B8B] rounded-3xl bg-transparent cursor-pointer relative z-10 ${wine?.meta?.length <= 1 ? 'pointer-events-none' : ''
                                        }`}
                                    >
                                      <span className="mr-2 flex items-center gap-3 poppins-medium">
                                        {selectedServedPrice[wine?.id] || (wine?.meta?.[0]?.served_price || "0.00")}
                                      </span>
                                      {wine?.meta?.length > 1 && (
                                        <RiArrowDownSLine
                                          className={`ml-1 mr-2 transform transition-transform duration-300 group-aria-expanded:rotate-180 translate-y-[-50%] absolute top-1/2 right-0 ${open ? "rotate-180" : ""
                                            }`}
                                          size={20}
                                        />
                                      )}
                                    </MenuButton>
                                  </div>
                                  {wine?.meta?.length > 1 && (
                                    <MenuItems
                                      anchor="bottom"
                                      className="mt-2 z-[999] bg-[#fffbfb] border w-[85px] text-black py-0 flex flex-col shadow-2xl rounded-xl relative focus-visible:outline-none overflow-hidden"
                                    >
                                      {wine?.meta?.map((item) => (
                                        <MenuItem key={item?.id}>
                                          {({ active }) => (
                                            <button
                                              onClick={() => handleServedPriceSelect(wine?.id, item?.served_price)}
                                              className={`px-3 py-2 w-full cursor-pointer border-t flex justify-center flex-row gap-[15px] ${active ? 'bg-[#8a2533]' : ''
                                                }`}
                                            >
                                              <span className={`text-xs text-[#303030] rounded-md flex items-center gap-3 poppins-regular ${active ? 'text-white' : ''
                                                }`}>
                                                {item?.served_price}
                                              </span>
                                            </button>
                                          )}
                                        </MenuItem>
                                      ))}
                                    </MenuItems>
                                  )}
                                </>
                              )}
                            </Menu>
                          </div>
                        </td>
                        <td className="py-4 px-2 text-left poppins-medium">
                          <span
                          className={`w-[85px] text-center block py-1 px-3 rounded-full ${wine?.status === "Active" || wine?.status === "Attivo"
                            ? "text-[#0AC83D] active_lable"
                            : "text-[#EB2D2D] inactive_lable"
                            }`}
                          >
                            {wine?.status ? (wine?.status === "Active" ? "Attivo" : "Inattivo") : "N/A"}
                            {/* - */}
                          </span>
                        </td>
                        {(hasPermission("Wines", "edit") ||
                          hasPermission("Wines", "view")) && (
                            <td className="py-4 px-2">
                              {hasPermission("Wines", "view") && (
                                <button
                                  className="text-red-700 m-2"
                                  onClick={() => handleView(wine)}
                                >
                                  <FaRegEye size={"20px"} />
                                </button>
                              )}
                              {hasPermission("Wines", "edit") && (
                                <button
                                  className="text-red-700"
                                  onClick={() => handleEdit(wine)}
                                >
                                  <TbEdit size={"20px"} />
                                </button>
                              )}
                            </td>
                          )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={9} className="text-center py-4">
                        No wines found
                      </td>
                    </tr>
                  )}
                </tbody>
              )}
            </table>
          </div>
          {wineData && wineData?.length > 0 && (
            <PaginationComponent
              page={page}
              totalPages={totalPages}
              rowsPerPage={rowsPerPage}
              setPage={setPage}
              setRowsPerPage={setRowsPerPage}
            />
          )}
        </section>
      ) : isViewing ? (
        <WineView
          currentWineData={currentWineData}
          handleCancel={handleCancel}
        />
      ) : (
        <WineEdit
          isLoading={isLoading}
          wineName={wineName}
          // setWineName={setWineName}
          b2bPrice={b2bPrice}
          servedPrice={servedPrice}
          glassPrice={glassPrice}
          setB2bPrice={setB2bPrice}
          setServedPrice={setServedPrice}
          setGlassPrice={setGlassPrice}
          currentWineData={currentWineData}
          handleSave={handleSave}
          handleCancel={handleCancel}
          handleView={handleView}
        />
      )}
    </>
  );
};

export default forwardRef(WineManagement);
